import { format } from 'date-fns';

const WeekSelect = ({ fromDay, toDay, onClickNextWeek, onClickPreviewWeek }) => {
    return (
        <div className="main-content__calendar-week-select">
            <button className="week-select-btn" type="button" onClick={onClickPreviewWeek}>
                <i className="fa-solid fa-chevron-left"></i>
            </button>
            <div className="main-content__calendar-week-title">
                <div>Weekdays</div>
                <div>
                    <span>{format(fromDay, "dd.MM.yyyy")}.</span>
                    <span>-</span>
                    <span>{format(toDay, "dd.MM.yyyy")}.</span>
                </div>
            </div>
            <button className="week-select-btn" type="button" onClick={onClickNextWeek}>
                <i className="fa-solid fa-chevron-right"></i>
            </button>
        </div>
    );
};

export default WeekSelect;
